import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as HomeSettingsActionCreators from "../../../actions/homeSettings.actions";
import UploadTemporaryFile from '../../controls/UploadTemporaryFile';

export interface IHomeSettingsProps {
    homeSettings: CreDtos.HomeSettings;
    load: Function;
    upsert: Function;
    isLoading: boolean;
    isSaving: boolean;
}

interface IHomeSettingsState {
    homeSettings: CreDtos.HomeSettings;
}

class HomeSettings extends React.Component<IHomeSettingsProps, IHomeSettingsState> {
    constructor(props: IHomeSettingsProps) {
        super(props);
        this.state = {
            homeSettings: new CreDtos.HomeSettings()
        }
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        this.props.load();
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isLoading && prevProps.isLoading) {
            this.setState({ homeSettings: { ...this.props.homeSettings } });
        } else if (!this.props.isSaving && prevProps.isSaving) {
            this.setState({ homeSettings: { ...this.props.homeSettings } });
        }
    }

    onValueChanged(fieldName: string, value: any) {
        var homeSettings = { ...this.state.homeSettings };
        homeSettings[fieldName] = value;
        this.setState({ homeSettings });
        
    }

    onSave() {
       this.props.upsert(this.state.homeSettings);
    }

    render() {
        let content;

        if (this.props.isLoading) {
            content = (
                <Spinner isOpen={this.props.isLoading} />
            );
        } else if (this.props.isSaving) {
            content = (
                <Spinner isOpen={this.props.isSaving} label="Saving" />
            );
        } else if (this.state.homeSettings) {
            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>First Paragraph</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Text</label>
                                            <input type="text"
                                                className="form-control"
                                                placeholder="The text to show, use <br /> for line breaks"
                                                disabled={this.props.isSaving}
                                                value={this.state.homeSettings.sectionOneText}
                                                onChange={(e) => this.onValueChanged("sectionOneText", e.target.value)}
                                                maxLength={2000} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Link</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder=""
                                                value={this.state.homeSettings.sectionOneLink}
                                                onChange={e => this.onValueChanged("sectionOneLink", e.target.value)}
                                                maxLength={2000} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Link Text</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder=""
                                                value={this.state.homeSettings.sectionOneLinkText}
                                                onChange={e => this.onValueChanged("sectionOneLinkText", e.target.value)}
                                                maxLength={2000} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <strong>Second Paragraph</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        {/* <div className="mb-0 form-group">
                                            <label>Text</label>
                                            <input type="text"
                                                className="form-control"
                                                placeholder="The text to show, use <br /> for line breaks"
                                                disabled={this.props.isSaving}
                                                value={this.state.homeSettings.sectionTwoText}
                                                onChange={(e) => this.onValueChanged("sectionTwoText", e.target.value)}
                                                maxLength={2000} />
                                        </div> */}
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Link</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder=""
                                                value={this.state.homeSettings.sectionTwoLink}
                                                onChange={e => this.onValueChanged("sectionTwoLink", e.target.value)}
                                                maxLength={2000} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Link Text</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder=""
                                                value={this.state.homeSettings.sectionTwoLinkText}
                                                onChange={e => this.onValueChanged("sectionTwoLinkText", e.target.value)}
                                                maxLength={2000} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.load()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        /*
        if (this.state.person) {

            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12 col-md-9 push-md-3">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>Person</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text" className="form-control"
                                                placeholder="First name..."
                                                disabled={this.props.isSaving}
                                                value={this.state.person.firstName}
                                                onChange={(e) => this.onValueChanged("firstName", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text"
                                                className="form-control"
                                                placeholder="Last name..."
                                                disabled={this.props.isSaving}
                                                value={this.state.person.lastName}
                                                onChange={(e) => this.onValueChanged("lastName", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <input type="text"
                                                className="form-control"
                                                placeholder="Defaults to first and last name if empty..."
                                                disabled={this.props.isSaving}
                                                value={this.state.person.title}
                                                onChange={(e) => this.onValueChanged("title", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label >Link (optional)</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder="https://www..."
                                                value={this.state.person.link}
                                                onChange={e => this.onValueChanged("link", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <select className="form-control" disabled={this.props.isSaving} onChange={e => this.onValueChanged("peopleType", e.target.value)}>
                                                <option value="1" selected={this.state.person.peopleType == 1}>External</option>
                                                <option value="2" selected={this.state.person.peopleType == 2}>Internal</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <UploadTemporaryFile onUpdated={(path) => this.onValueChanged("img", path)} />
                                        <p>The preferred aspect ratio 5:4</p>
                                    </div>
                                    <div className="col-12 mb-1 show-sm">
                                        <div>
                                            <img src={img} style={{width: "100%"}} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.person.enabled}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("enabled", !this.state.person.enabled)}
                                            />
                                            Enabled
                                    </label>
                                    </div>
                                    {categories}
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.cancel()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-12 col-md-3 pull-md-9 hide-sm">
                                <div>
                                    <img src={img} style={{width: "100%"}} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        */
        return (
            <div>
                {content}
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        homeSettings: state.homeSettings.homeSettings,
        isLoading: state.homeSettings.isLoading,
        isSaving: state.homeSettings.isSaving
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            load: HomeSettingsActionCreators.homeSettingsRequest,
            upsert: HomeSettingsActionCreators.homeSettingsUpsertRequest
        },
        dispatch
    );
};


const HomeSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(
    HomeSettings
);

export default HomeSettingsContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/Home/HomeSettings.tsx